/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer } from '@/application';
import { SignInPageService } from '@/pages/SignIn';
import { logger as log } from '@common/logger';
import toast from 'react-hot-toast';

const MODULE_NAME = 'profile.machines.states.signInUser';

const getSrv = () => {
  return vappContainer.get<SignInPageService>(SignInPageService.displayName);
};

export const getSignInType = async (context: any, event: any) => {
  const currentState = 'GET_SIGN_IN_TYPE';
  const method = 'getSignInType';

  return new Promise(async (resolve, reject) => {
    try {
      log.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      // const srv = getSrv();
      // const content = await srv.getSignInType(event?.payload);
      const content = { signInType: 'password', error: '' };
      log.log(MODULE_NAME, 'getSignInType=', content);
      return resolve({
        key: 'GET_SIGN_IN_TYPE_SUCCESS',
        value: {
          ...(content || {}),
          email: event?.payload?.email,
        },
      });
      if (content && content?.signInType) {
      } else {
        const msg = content?.error?.replace('UnauthorizedError:', '');
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        toast.error(msg);
        return reject({
          key: 'GET_SIGN_IN_TYPE_FAILURE',
          value: content,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err}`);
      let message =
        err?.replace('UnauthorizedError:', '') ??
        'Something went wrong please try again!';
      return reject({
        key: 'GET_SIGN_IN_TYPE_FAILURE',
        value: message,
      });
    }
  });
};
